// extracted by mini-css-extract-plugin
export default {"card":"card___9GIsx","richMedia":"richMedia___10q0C","content":"content___24_63"};